// extracted by mini-css-extract-plugin
export default {"tooltipInner":"truncatedTooltip_tooltipInner__nOO4i"};